import angular from "angular";

angular
    .module('ui-common')
    .filter('batteryPercentage', ['BatteryPercentageService', BatteryPercentageFilter]);

function BatteryPercentageFilter(BatteryPercentageService) {
    return function (voltage, beaconType) {
        return BatteryPercentageService.calc(voltage, beaconType);
    };
}
